import Postmonger from 'postmonger';
import SampleInteraction from './sampleInteraction';

// this function is for example purposes only. it sets ups a Postmonger
// session that emulates how Journey Builder works. You can call jb.ready()
// from the console to kick off the initActivity event with a mock activity object
export function setupExampleTestHarness() {
    const isLocalhost =
        location.hostname === 'localhost' || location.hostname === '127.0.0.1';
    if (!isLocalhost) {
        // don't load the test harness functions when running in Journey Builder
        return;
    }

    const jbSession = new Postmonger.Session();
    const jb: any = {
        activity: SampleInteraction.onInitActivity,
    };
    window.jb = jb;

    jbSession.on('setActivityDirtyState', function (value) {
        console.log('[echo] setActivityDirtyState -> ', value);
    });

    jbSession.on('requestInspectorClose', function () {
        console.log('[echo] requestInspectorClose');
    });

    jbSession.on('updateActivity', function (activity) {
        console.log(
            '[echo] updateActivity -> ',
            JSON.stringify(activity, null, 4),
        );
    });

    jbSession.on('ready', function () {
        console.log('[echo] ready');
        console.log(
            '\tuse jb.ready() from the console to initialize your activity',
        );
    });

    // fire the ready signal with an example activity
    jb.ready = function () {
        jbSession.trigger('initActivity', SampleInteraction.onInitActivity);

        jbSession.trigger('requestedSchema', SampleInteraction.requestedSchema);

        // Simulated the completion of "requestedInteractionDefaults"
        jbSession.trigger(
            'requestedInteractionDefaults',
            SampleInteraction.requestedInteractionDefaults,
        );

        // Simulated the completion of "requestedInteraction"
        jbSession.trigger(
            'requestedInteraction',
            SampleInteraction.requestedInteraction,
        );
    };
}
